<template>
	<div>
		<div class="flex flex-wrap enterprise">
			<div class="enterprise-item" v-for="(item,index) in enterpriseList" :key="index">
				<div class="enterprise-name flex align-c">
					<el-image class="enterprise-icon"
						:src="require('@/assets/images/index/hxek.png')"></el-image>
					<div>
						<div class="enterprise-title col-333 bold">鸿星尔克</div>
						<div class="enterprise-sub col-666">已上市 | 100000人以上 | 电子商务</div>
					</div>
				</div>
				<div class="recruit">
					<div class="recruit-item" v-for="(item,index) in 3" :key="index">
						<div class="flex align-c justify-sb">
							<div class="over-1 recruit-title col-333 bold">
								资深财务实时顾问（项目经理
							</div>
							<div class="recruit-price bold">14-18K</div>
						</div>
						<div class="flex align-c mt-12 col-333">
							<div class="recruit-label flex align-c">
								厦门 思明区 观音山
							</div>
							<div class="recruit-label flex align-c">
								3-5年
							</div>
							<div class="recruit-label flex align-c">
								本科
							</div>
						</div>
					</div>
				</div>
				<div class="recruit-more flex align-c justify-c">
					更多职位
				</div>
			</div>
			<div class="look-more flex align-c justify-c">查看更多</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				enterpriseList:[{},{},{},{},{},{}],
			}
		},
		props:{
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.enterprise{
		padding: 0 7px;
	}
	.enterprise-item{
		width: 396px;
		height: 430px;
		border-radius: 8px;
		background: #FFFFFF;
		margin: 0 13px 30px 13px;
		overflow: hidden;
	}
	.enterprise-name{
		background: linear-gradient(270deg, #F9F9F8 0%, #F5FCFC 100%);
		height: 68px;
		padding: 0 20px;
	}
	.enterprise-icon{
		width: 40px;
		height: 40px;
		border-radius: 4px;
		margin-right: 10px;
	}
	.enterprise-title{
		font-size: 16px;
		line-height: 22px;
	}
	.enterprise-sub{
		font-size: 12px;
		line-height: 16px;
		margin-top: 6px;
	}
	.recruit{
		padding: 6px 6px 20px 6px;
	}
	.recruit-item{
		height: 82px;
		margin-top: 8px;
		border: 1px solid #F1F1F1;
		border-radius: 6px;
		padding: 12px 10px 0 14px;
	}
	.recruit-title{
		width: 170px;
		font-size: 14px;
		line-height: 20px;
	}
	.recruit-price{
		font-size: 14px;
		line-height: 20px;
		color: #FE574A;
	}
	.mt-12{
		margin-top: 12px;
	}
	.recruit-label{
		padding: 0 10px;
		height: 26px;
		margin-right: 6px;
		border-radius: 2px;
		background: #F8F8F8;
		font-size: 13px;
	}
	.recruit-more{
		width: 154px;
		height: 40px;
		margin: auto;
		border-radius: 8px;
		border: 1px solid #169BD5;
		font-size: 13px;
		color: #169BD5;
	}
	.look-more{
		width: 200px;
		height: 46px;
		border-radius: 8px;
		background: rgba(22, 155, 213, .1);
		margin: auto;
		color: #169BD5;
		font-size: 13px;
	}
</style>